import { AppData } from "../../AppDataProvider";

export type RemoveDiscountCodeOpts = {
  appData: AppData;
};

export const removeDiscountCode = (
  options: RemoveDiscountCodeOpts
): AppData => {
  const { bookingData } = options.appData;

  const updatedBookingData = {
    ...bookingData,
  };

  delete updatedBookingData.discountCode;

  return {
    ...options.appData,
    bookingData: updatedBookingData,
  };
};
